import { TabletElements, TabletOpenLandscapeParams } from "../../types/index-type";
import { initQueryselectorTablet } from "../init-queryselector-tablet";



const isHTMLElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement;

export const MovingGotoOpenTabletHorizonal = ({
  wholeLeftPositionOpen,
  sidebarColumnsLandscape,
  mainColumnsLandscape,
}: TabletOpenLandscapeParams): void => {
  const { body, grid, sideBarButton, page }: TabletElements = initQueryselectorTablet();

  if (!isHTMLElement(grid) || !isHTMLElement(sideBarButton)) {
    return;
  }

  grid.style.left = `${wholeLeftPositionOpen}`;
  grid.style.gridTemplateColumns = `${sidebarColumnsLandscape}vw ${mainColumnsLandscape}vw`;

  if (isHTMLElement(page)) {
    page.style.width = "calc(100% - 24vw - 6px)";
    page.style.transition = "0.5s";
  }

  grid.style.transition = "0.5s";
  sideBarButton.textContent = "CLOSE";
  body?.classList.remove("sidebar-closed");
  body?.classList.add("sidebar-open");

  localStorage.setItem("toggleSlider", "open");

  if (isHTMLElement(body)) {
    body.style.opacity = "1";
  }
};
